const { serialize } = require("../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/tmb",
  },
  actions: {
    // ============ Katalog (o'quv qurollari nomlari) ============
    getMaterials({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/materials/?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    addMaterial({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/materials/add`, method: "POST", data }, { root: true });
      }
    },
    saveMaterial({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/materials/save`, method: "POST", data }, { root: true });
      }
    },
    toggleMaterialActive({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/materials/toggle-active`, method: "POST", data }, { root: true });
      }
    },
    deleteMaterial({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/materials/delete`, method: "POST", data }, { root: true });
      }
    },

    // ============ Kategoriyalar (asosiy ajratish + dinamik maydonlar) ============
    getCategories({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/categories/?${serialize(options || {})}`, method: "GET", data: {} }, { root: true });
      }
    },
    addCategory({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/categories/add`, method: "POST", data }, { root: true });
      }
    },
    saveCategory({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/categories/save`, method: "POST", data }, { root: true });
      }
    },
    toggleCategoryActive({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/categories/toggle-active`, method: "POST", data }, { root: true });
      }
    },
    deleteCategory({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/categories/delete`, method: "POST", data }, { root: true });
      }
    },

    // ============ Turlar (kategoriya ichidagi) ============
    getMaterialTypes({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/material-types/?${serialize(options || {})}`, method: "GET", data: {} }, { root: true });
      }
    },
    addMaterialType({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/material-types/add`, method: "POST", data }, { root: true });
      }
    },
    saveMaterialType({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/material-types/save`, method: "POST", data }, { root: true });
      }
    },
    toggleMaterialTypeActive({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/material-types/toggle-active`, method: "POST", data }, { root: true });
      }
    },
    deleteMaterialType({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/material-types/delete`, method: "POST", data }, { root: true });
      }
    },

    // ============ Prixod (kirim) ============
    getIntakes({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/intakes/?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    getIntake({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/intakes/id/${options._id}`, method: "GET", data: {} }, { root: true });
      }
    },
    addIntake({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/intakes/add`, method: "POST", data }, { root: true });
      }
    },
    deleteIntake({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/intakes/delete`, method: "POST", data }, { root: true });
      }
    },
    moveIntake({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/intakes/move`, method: "POST", data }, { root: true });
      }
    },

    // ============ Dalolatnomalar (transfer aktlari) ============
    getActs({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    getActHolders({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/holders?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    getAct({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/id/${options._id}`, method: "GET", data: {} }, { root: true });
      }
    },
    createAct({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/create`, method: "POST", data }, { root: true });
      }
    },
    createReturnAct({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/create-return`, method: "POST", data }, { root: true });
      }
    },
    uploadSignedAct({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/upload-signed`, method: "POST", data }, { root: true });
      }
    },
    getActFile({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/file/${options.actId}`, method: "GET", data: {} }, { root: true });
      }
    },
    resetAct({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/reset`, method: "POST", data }, { root: true });
      }
    },
    moveAct({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/acts/move`, method: "POST", data }, { root: true });
      }
    },

    // ============ Jarimalar (zarar/yo'qotish) ============
    getFines({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/fines/?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    getFineMaterialHolders({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/fines/material-holders?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    addFine({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/fines/add`, method: "POST", data }, { root: true });
      }
    },
    markFinePaid({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/fines/mark-paid`, method: "POST", data }, { root: true });
      }
    },
    cancelFine({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/fines/cancel`, method: "POST", data }, { root: true });
      }
    },

    // ============ Dashboard (ombor holati / xronologiya) ============
    getBalances({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/dashboard/balances?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    getMaterialTimeline({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/dashboard/material/${options._id}?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    getHolderHoldings({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/dashboard/holder?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    getReturnStatus({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/dashboard/return-status?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    recomputeBalances({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/dashboard/recompute-balances`, method: "POST", data }, { root: true });
      }
    },
  },
};
